module.exports = __webpack_public_path__ + "img/footer-payments.8e06194.png";